import { MembersByZone } from '../../../../../types'
import { useBaseDate } from '../../../../../hooks/use-base-date'

export const useIsActiveZone = (zone: MembersByZone) => {
  const { offsetTime, rootTime } = useBaseDate(zone.timezone)

  return offsetTime === rootTime
}
